<template>
  <div id="app" >
    <progress-bar/>
    <router-view/>
  </div>
</template>

<script>
import ProgressBar from './components/Pages/components/ProgressBar'
export default {
  name: 'App',
  components: {ProgressBar},
  metaInfo: {
    title: 'Unrival',
  }
}
</script>

<style type="scss">
@import "assets/scss/style.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue